function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.trim.js";
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/popup/style';
import 'vant/es/icon/style';
import groupScan from '../../../assets/groupScan.png';
var DEFAULT_EMAIL = 'yingsai2025@163.com';
export default {
  name: 'CreatorContestKefuPopup',
  props: {
    /** 是否展示弹层（由父级 `v-model:show` 控制） */
    show: {
      type: Boolean,
      default: false
    },
    /** 二维码图片地址；不传则使用内置客服图 */
    qrSrc: {
      type: String,
      default: ''
    },
    /** 联系邮箱 */
    contactEmail: {
      type: String,
      default: DEFAULT_EMAIL
    }
  },
  emits: ['update:show'],
  data: function data() {
    return {
      overlayStyle: {
        background: 'rgba(0, 0, 0, 0.6)'
      }
    };
  },
  computed: {
    /**
     * 实际展示的二维码地址
     * @returns {string}
     */
    resolvedQrSrc: function resolvedQrSrc() {
      return this.qrSrc || groupScan;
    }
  },
  methods: {
    /**
     * 同步弹层显隐到父组件
     * @param {boolean} value - 是否显示
     * @returns {void}
     */
    onUpdateShow: function onUpdateShow(value) {
      this.$emit('update:show', value);
    },
    /**
     * 点击关闭图标收起弹层
     * @returns {void}
     */
    onCloseClick: function onCloseClick() {
      this.onUpdateShow(false);
    },
    /**
     * 将联系邮箱写入剪贴板
     * @returns {Promise<void>}
     */
    onCopyEmail: function onCopyEmail() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var text, _navigator$clipboard, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              text = String(_this.contactEmail || '').trim();
              if (text) {
                _context.n = 1;
                break;
              }
              showToast('邮箱为空');
              return _context.a(2);
            case 1:
              _context.p = 1;
              if (!(typeof navigator !== 'undefined' && (_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText)) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return navigator.clipboard.writeText(text);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _this.fallbackCopyText(text);
            case 4:
              showToast('已复制邮箱');
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              showToast('复制失败，请长按邮箱手动复制');
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 5]]);
      }))();
    },
    /**
     * 剪贴板 API 不可用时的降级复制
     * @param {string} text - 待复制文本
     * @returns {void}
     */
    fallbackCopyText: function fallbackCopyText(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
  }
};